import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { LoadPort } from 'src/app/core/models/load-port';
import { LoadPortService } from 'src/app/core/services/general/load-port.service';

@Component({
  selector: 'app-load-port-input',
  templateUrl: './load-port-input.component.html',
  styleUrls: ['./load-port-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: LoadPortInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: LoadPortInputComponent,
    },
  ],
})
export class LoadPortInputComponent {
  @Input()
  title = "Select Load Port...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public loadPortsList: Array<CustomSelectOption> = [];

  constructor(
    private loadPortService: LoadPortService,
  ) {
    this.loadPortService
      .all()
      .subscribe((res: Array<LoadPort>) => {
        this.loadPortsList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.loadPortsList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
